import React, { useState } from 'react';
import TabsComponent from '../../components/Tabs/Tabs';
import { useHistory, useLocation } from 'react-router-dom';
import { MasterBidding } from '../Reusables/Bidding/MasterBidding/bidding';
import { BundleBid } from '../Reusables/Bidding/BundleBidding/BundleBid';
import { BidRequest } from '../Reusables/Bidding/BidRequest/BidRequest';
import { SymetricalBundle } from '../Reusables/Bidding/SymetricalBundle/SymetricalBundle';

const MasterBiddingMain = () => {
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const queryParamsData = {
        tab: Number(queryParams.get('tab') || 0),
        subTab: Number(queryParams.get('subTab') || 0),
        regulation: queryParams.get('regulation'),
        bidDate: queryParams.get('bidDate'),
        admin: queryParams.get('admin'),
        customer: queryParams.get('customer'),
        filter: queryParams.get('filter'),
    };

    const [selectedIndex, setSelectedIndex] = useState(queryParamsData.tab);

    const updateQueryParams = (type, value) => {
        queryParams.set(type, value);
        history.push({ search: queryParams.toString() });
    };

    const tabs = [
        {
            name: 'Bidding',
            component: <MasterBidding heading={'Master Bidding'} />,
            tabId: 1,
        },
        {
            name: 'Bundle Bidding',
            component: <BundleBid heading={'Master Bidding'} />,
            tabId: 2,
        },
        {
            name: 'Linked Bundle',
            component: <SymetricalBundle />,
            tabId: 3,
        },
        {
            name: 'Bid Request',
            component: <BidRequest />,
            tabId: 4,
        },
    ];

    return (
        <div className={'ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                    updateQueryParams('tab', index);
                }}
            />
        </div>
    );
};

export default MasterBiddingMain;
